import { render, staticRenderFns } from "./TraceabilitySearchBatch.vue?vue&type=template&id=65131379&scoped=true"
import script from "./TraceabilitySearchBatch.vue?vue&type=script&lang=js"
export * from "./TraceabilitySearchBatch.vue?vue&type=script&lang=js"
import style0 from "./TraceabilitySearchBatch.vue?vue&type=style&index=0&id=65131379&prod&lang=scss&scoped=true"
import style1 from "./TraceabilitySearchBatch.vue?vue&type=style&index=1&id=65131379&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65131379",
  null
  
)

export default component.exports